/** @jsx jsx */
import { sizer } from "@trueskin-web/functions"
import { jsx } from "@trueskin-web/theme"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"

import { useFormControl } from "./form-control"
import Icon from "./icon"

const sizes = {
  xlg: {
    height: 40,
    width: 40,
  },
  lg: {
    height: 32,
    width: 32,
  },
  md: {
    height: 24,
    width: 24,
  },
  sm: {
    height: 16,
    width: 16,
  },
  xsm: {
    height: 12,
    width: 12,
  },
}

const Checkbox = (props) => {
  const { size = "sm", children, isFullWidth, ...otherProps } = props
  const formControl = useFormControl(props)

  return (
    <label
      sx={{
        display: "flex",
        cursor: "pointer",
        width: isFullWidth && "100%",
        opacity: formControl.isDisabled ? 0.4 : 1,
      }}
    >
      <input
        type="checkbox"
        disabled={formControl.isDisabled}
        aria-invalid={formControl.isInvalid}
        {...otherProps}
        sx={{
          appearance: "none",
          backgroundColor: "transparent",
          margin: 0,
          position: "absolute",
        }}
      />
      <div
        sx={{
          display: "inline-flex",
          flexShrink: 0,
          alignSelf: "flex-start",
          justifyContent: "center",
          mt: 1,
          border: "1px",
          ...sizer(sizes, size),
          "& > *": {
            opacity: 0,
          },
          "input:checked ~ &": {
            bg: "primary",
            borderColor: "primary",
            "& > *": {
              opacity: 1,
            },
          },
          "input:focus ~ &, input:hover ~ &": {
            boxShadow: "0 0 0 1px",
          },
          "input[aria-invalid=true] ~ &": {
            borderColor: "attention",
          },
        }}
      >
        <Icon icon={checkIcon} size={size} color="#fff" />
      </div>
      {children && (
        <div
          sx={{
            alignSelf: "center",
            ml: 2,
            userSelect: "none",
          }}
        >
          {children}
        </div>
      )}
    </label>
  )
}

export default Checkbox
export { sizes }
